import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum AceClaimAction {
  CREATE_CLAIM = "CREATE_ACE_CLAIM",
  FETCH_CLAIM_INFO = "FETCH_ACE_CLAIM_INFO",
  DELETE_CLAIM_CREATE_NEW = "ACE_DELETE_CLAIM_CREATE_NEW",
  INSERT_CLAIM_ITEMS = "ACE_INSERT_CLAIM_ITEMS",
  REMOVE_CLAIM_ITEM = "ACE_REMOVE_CLAIM_ITEM",
  INSERT_CLAIM_ITEM_DAMGES = "ACE_INSERT_CLAIM_ITEM_DAMGES",
  SUBMIT_CLAIM = "SUBMIT_ACE_CLAIM",
  SET_CLAIM_INFO = "SET_ACE_CLAIM_INFO",
  CLAIM_ITEM_DELETE_IMAGE = "ACE_CLAIM_ITEM_DELETE_IMAGE",
  DELETE_DAMAGE_ITEM = "DELETE_ACE_DAMAGE_ITEM",
  SET_WARRNTY_ITEMS = "ACE_SET_WARRNTY_ITEMS",
  CLEAN_UP = "ACE_CLEAN_UP_CLAIM_INFO",
  CLAIM_ITEM_FILE_UPLOAD = "ACE_CLAIM_ITEM_FILE_UPLOAD",
}

export interface AceClaimState {
  claimId: string;
  statusCode: string;
  status: string;
  plan: {};
  data: {};
  customerId: string;
  customer_data: {};
  warranty_items: [];
  claim_items: any[];
}

export type AceClaimActionTypes = ReturnType<InferValueTypes<typeof actions>>;

export const AceClaimScope = "Ace-claim";
